var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "cd-container summary" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "p-0",
              attrs: { sm: "12", md: "12", lg: "12", xl: "12" }
            },
            [
              _c(
                "b-container",
                { staticClass: "cd-summary-container p-0" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "cd-summary-container-main",
                          attrs: { sm: "12", md: "12", lg: "6", xl: "6" }
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "cd-summary-subheadline cd-primary-black"
                            },
                            [_vm._v(" Fahrzeugdetails ")]
                          ),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v("Marke ")
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.maker ? _vm.maker.label : "") +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v("Modell ")
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.model ? _vm.model.label : "") +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v("Karosserie ")
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.bodyDesign ? _vm.bodyDesign.label : ""
                                ) +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v("Ausstattungslinie ")
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.trimLevel ? _vm.trimLevel.label : ""
                                ) +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v("Farbe ")
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.selectedColor
                                    ? _vm.selectedColor.label
                                    : ""
                                ) +
                                " "
                            )
                          ])
                        ]
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "12", md: "12", lg: "6", xl: "6" } },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "cd-summary-subheadline cd-primary-black"
                            },
                            [_vm._v(" Performance ")]
                          ),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v("Kraftstoff ")
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.engine ? _vm.engine.fuel_type : "") +
                                " " +
                                _vm._s(
                                  _vm.isPluginHybrid(_vm.engine)
                                    ? "/ " + _vm.getFuel(_vm.engine)
                                    : ""
                                ) +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v("Leistung ")
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.engine
                                    ? _vm.engine.technical_data.max_power_kw
                                    : ""
                                ) +
                                "kW/" +
                                _vm._s(
                                  _vm.engine
                                    ? _vm.engine.technical_data.max_power_hp
                                    : ""
                                ) +
                                " PS "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(
                                  !_vm.hasWltpData(_vm.engine)
                                    ? "Energieeffizienzklasse"
                                    : "CO2-Klasse"
                                ) +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  !_vm.isPluginHybrid(_vm.engine)
                                    ? _vm.getCo2Class(_vm.engine)
                                    : _vm.getWltpCo2ClassOnly(_vm.engine) +
                                        " | " +
                                        _vm.getWltpSecondaryCo2ClassOnly(
                                          _vm.engine
                                        )
                                ) +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v(
                              "CO2-Emissionen" +
                                _vm._s(
                                  _vm.isPluginHybrid(_vm.engine)
                                    ? " gewichtet "
                                    : " "
                                ) +
                                "kombiniert "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-value" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.engine
                                    ? _vm.getCo2(_vm.engine) + "g/km"
                                    : ""
                                ) +
                                " "
                            )
                          ]),
                          _c("span", { staticClass: "cd-summary-title" }, [
                            _vm._v(" —"),
                            _c("br"),
                            _vm._v(
                              "Verbrauch kombiniert" +
                                _vm._s(
                                  _vm.isPluginHybrid(_vm.engine)
                                    ? " gewichtet"
                                    : ""
                                )
                            )
                          ]),
                          _vm.engine &&
                          (_vm.engine.fuel_type != "Elektro" ||
                            (_vm.engine.fuel_type === "Elektro" &&
                              _vm.getCo2(_vm.engine) !== "-" &&
                                _vm.getCo2(_vm.engine) != "0" &&
                                _vm.getCo2(_vm.engine) != "0.0"))
                            ? _c("span", { staticClass: "cd-summary-value" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.engine
                                        ? _vm.isPluginHybrid(_vm.engine)
                                          ? _vm.getWltpConsumptionCombinedWeighted(
                                              _vm.engine
                                            ) +
                                            "l " +
                                            _vm.getFuel(_vm.engine) +
                                            "/100km"
                                          : _vm.engine.fuel_type ==
                                              "Wasserstoff" ||
                                            _vm.engine.fuel_type == "Erdgas"
                                          ? _vm.getGasConsumption(_vm.engine) +
                                            "kg/100km"
                                          : _vm.getFuelConsumption(_vm.engine) +
                                            "l/100km"
                                        : ""
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e(),
                          _vm.engine &&
                          !_vm.isPluginHybrid(_vm.engine) &&
                          _vm.engine.fuel_type == "Elektro"
                            ? _c("span", { staticClass: "cd-summary-value" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.engine
                                        ? _vm.getPowerConsumption(_vm.engine) +
                                            " kWh/100km"
                                        : "-"
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e(),
                          _vm.isPluginHybrid(_vm.engine)
                            ? _c("span", { staticClass: "cd-summary-value" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.engine
                                        ? _vm.getEnergyConsumptionWeighted(
                                            _vm.engine
                                          ) + " kWh/100km"
                                        : "-"
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e(),
                          _vm.isPluginHybrid(_vm.engine)
                            ? _c("span", { staticClass: "cd-summary-title" }, [
                                _vm._v(" —"),
                                _c("br"),
                                _vm._v(
                                  "Verbrauch kombiniert bei entladener Batterie"
                                )
                              ])
                            : _vm._e(),
                          _vm.isPluginHybrid(_vm.engine)
                            ? _c("span", { staticClass: "cd-summary-value" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getWltpConsumptionCombinedDepleted(
                                        _vm.engine
                                      ) + " l/100km"
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-container",
                        {
                          staticClass: "cd-summary-extras-categories-container"
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "cd-summary-subheadline cd-primary-black"
                                  },
                                  [_vm._v(" Sonderausstattung ")]
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._l(_vm.extrasCategories, function(extraCat) {
                            return _c(
                              "b-row",
                              {
                                key: extraCat.categoryName,
                                staticClass: "cd-summary-extras-category-row"
                              },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "cd-extra-category-headline"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(extraCat.categoryName) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "b-container",
                                      {
                                        staticClass: "cd-summary-extras-items"
                                      },
                                      _vm._l(extraCat.extras, function(extra) {
                                        return _c(
                                          "b-row",
                                          { key: extra.id },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "10" } },
                                              [
                                                _c("ul", [
                                                  _c("li", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "cd-summary-extra-label"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(extra.label)
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "2" } },
                                              [
                                                extra.price_gross
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "cd-summary-extra-price"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatCurrency"
                                                            )(extra.price_gross)
                                                          ) + " €"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                !extra.price_gross
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "cd-summary-extra-price"
                                                      },
                                                      [_vm._v("inkl.")]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        !_vm.hasWltpData(_vm.engine)
                          ? _c(
                              "h3",
                              {
                                staticClass:
                                  "cd-summary-subheadline cd-primary-black energy-eficiency-headline"
                              },
                              [_vm._v(" CO2 - Effizienz ")]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "co2class-box-big" },
                          [
                            _c("EnergyEfficiencyBox", {
                              attrs: { engine: _vm.engine }
                            })
                          ],
                          1
                        ),
                        _c("p", { staticClass: "cd-subnote" }, [
                          _vm._v(
                            " Auf der Grundlage der gemessenen CO2-Emissionen unter Berücksichtigung der Masse des Fahrzeugs ermittelt. Weitere Informationen zum offiziellen Kraftstoffverbrauch und den offiziellen spezifischen CO2-Emissionen neuer Personenkraftwagen können dem Leitfaden über den Kraftstoffverbrauch und die CO2-Emissionen neuer Personenkraftwagen entnommen werden, der an allen Verkaufsstellen und bei "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://www.dat.de",
                                target: "_blank"
                              }
                            },
                            [_vm._v("www.dat.de")]
                          ),
                          _vm._v(" unentgeltlich erhältlich ist."),
                          _c("br"),
                          _c("br"),
                          _vm._v(
                            "Informationen über Kraftstoffverbrauch, CO2-Emissionen und Stromverbrauch i.S.d. Pkw-EnVKV downloaden. "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-container",
        { staticClass: "d-block d-xs-block d-sm-block d-md-block d-lg-none" },
        [_c("b-col", [_c("SidebarButton")], 1)],
        1
      ),
      _c(
        "b-container",
        { staticClass: "d-block d-xs-block d-sm-block d-md-block d-lg-none" },
        [
          _c(
            "b-row",
            { staticClass: "cd-offer-container" },
            [
              _c("b-col", { staticClass: "text-center" }, [
                _c(
                  "a",
                  {
                    staticClass: "cd-offer-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.downloadOfferPdf()
                      }
                    }
                  },
                  [_vm._v("Konfiguration drucken")]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }